import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './influencers-agency-title-breadcrumb.scss';

type Props = {
  title: string,
  onCancel: () => void
}

const InfluencersAgencyTitleBreadcrumb = ({ title, onCancel }: Props) => (
  <div
    className="influencers-agency-title-breadcrumb--container"
    onClick={onCancel}
  >
    <SVGDynamicIcon
      name="chevron-left-custom-fg"
      width={16}
      height={16}
      customColor="grey"
      clickable
    />
    <div className="influencers-agency-title-breadcrumb--text">
      {title}
    </div>
  </div>
);

export default InfluencersAgencyTitleBreadcrumb;
